import { useQueryClient, useMutation } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import { Sentry } from "../../utils"

type MutationFnParams = {
  paymentRequestId: string
  paymentMethodId: string
  savePaymentMethod: boolean
}

type StartCardPaymentRequestProps = {
  onSuccess?: () => void
}

export function useStartCardPaymentRequest({ onSuccess }: StartCardPaymentRequestProps) {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, MutationFnParams>({
    mutationFn: async ({ paymentRequestId, paymentMethodId, savePaymentMethod }) => {
      await fetcher(
        `/Transaction/PaymentRequest/${paymentRequestId}/StartCardPayment`,
        {
          method: "POST",
          body: JSON.stringify({ paymentMethodId, SavePaymentMethod: savePaymentMethod }),
        },
        {
          useAccessToken: true,
        }
      )
    },
    onSuccess: (response, { paymentRequestId }) => {
      queryClient.setQueryData(["StartCardPayment"], response)
      queryClient.invalidateQueries({
        queryKey: [`paymentRequest/${paymentRequestId}/allowedMethods`],
      })
      if (onSuccess) {
        onSuccess()
      }
    },
    onError: (error, { paymentRequestId }) => {
      queryClient.invalidateQueries({
        queryKey: [`paymentRequest/${paymentRequestId}/allowedMethods`],
      })
      Sentry.captureException(error)
    },
  })
}
